
import { of as observableOf,  Observable, firstValueFrom } from 'rxjs'

import { catchError, tap, map } from 'rxjs/operators'
import { FailedPost } from 'interfaces'
import { StoreThunkAction, StoreThunkDispatch, createAppAsyncThunk } from 'store/state'
import { V1 } from './net'
import { postsResponseAdapter } from '../adapters/posts'
import { mapPostsToBuckets } from './mapPostsToBuckets'
import { ContentType } from 'shared'

/** FETCH POSTS ACTIONS */
type FailedResponse = { posts: FailedPost[], page: number, totalPostsCount: number }
export function getFailedPosts(
  page: number, 
  pageIds: string[], 
  ppids?: string[], 
  query?: string,
  types?: ContentType[], 
  searchInArticleSummary?: boolean,
  bucketId?: string

): StoreThunkAction<Observable<FailedResponse>> {
  return (dispatch: StoreThunkDispatch) => {
    return dispatch(V1.getFailedPosts(page, pageIds, ppids, query, types, searchInArticleSummary, bucketId)).pipe(
      map(response => {
        const posts = postsResponseAdapter<FailedPost>(response)
        return {
          posts: dispatch(mapPostsToBuckets(posts)),
          page,
          totalPostsCount: response.postsCount
        }
      }))
  }
}

export const getFailedPostsCount = createAppAsyncThunk(
  'post/failed/getCount',
  async (ppids: string[], { dispatch, rejectWithValue }) => {
    try {
      const response = await firstValueFrom(dispatch(V1.getFailedPostsCount(ppids)))
      return { ppids, ...response }
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export function getFailedPostsCountObservable(ppids: string[]): StoreThunkAction<Observable<{ ppids: string[], hasFailedPosts: boolean }>> {
  return (dispatch: StoreThunkDispatch) => {
    return dispatch(V1.getFailedPostsCount(ppids)).pipe(
      map(response => ({ ppids, ...response })),
      tap((response) => {
        dispatch(getFailedPostsCount.fulfilled(response, '', ppids))
      }),
      catchError((error) => {
        dispatch(getFailedPostsCount.rejected(error, '', ppids))
        return observableOf({ ppids, hasFailedPosts: false })
      }))
  }
}
